import type { ExperimentConfig } from '../@types'

// Second iteration (DEV-35238): the i1 variant-C design, replayed on the funnels whose billing modal
// defaults to the old tabs checkout. The consent-popup variant is dropped, so this is the only
// treatment and takes slot B (`~1`).
// Each entry has a ready test URL above it.
const variantB = () => import('@/modules/Paywall/instances/experiments/web_compliance_jun_2026/__b')

const config: ExperimentConfig[] = [
	{
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=male&exp=web_compliance_jun_2026~1
		male: { paywall: { experiment: variantB } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-yoga&exp=web_compliance_jun_2026~1
		'activity-female-yoga': { paywall: { experiment: variantB } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-workouts&exp=web_compliance_jun_2026~1
		'activity-male-chair-workouts': { paywall: { experiment: variantB } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-walking&exp=web_compliance_jun_2026~1
		'activity-male-walking': { paywall: { experiment: variantB } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-pr&exp=web_compliance_jun_2026~1
		'activity-female-tai-chi-walking-pr': { paywall: { experiment: variantB } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga&exp=web_compliance_jun_2026~1
		'activity-male-tai-chi-yoga': { paywall: { experiment: variantB } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga-pr&exp=web_compliance_jun_2026~1
		'activity-male-tai-chi-yoga-pr': { paywall: { experiment: variantB } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi&exp=web_compliance_jun_2026~1
		'activity-male-chair-tai-chi': { paywall: { experiment: variantB } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi-al&exp=web_compliance_jun_2026~1
		'activity-male-chair-tai-chi-al': { paywall: { experiment: variantB } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-walking-al&exp=web_compliance_jun_2026~1
		'activity-male-tai-chi-walking-al': { paywall: { experiment: variantB } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-military-calisthenics&exp=web_compliance_jun_2026~1
		'activity-male-military-calisthenics': { paywall: { experiment: variantB } },
		// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga-al&exp=web_compliance_jun_2026~1
		'activity-male-tai-chi-yoga-al': { paywall: { experiment: variantB } },
	},
]

export default config
